import { promiseTimeout } from 'lib/async';
import { wsDestroy } from 'lib/socket';

let redirectInProgress: false | string = false;

export const redirect = async (opts: RedirectTo, beep?: boolean) => {
  try {
    if (beep) await promiseTimeout(site.sound.play('genericNotify'), 1000);
  } catch (e) {
    console.warn(e);
  }
  let url: string;
  if (typeof opts === 'string') url = opts;
  else {
    url = opts.url;
    if (opts.cookie) {
      document.cookie = [
        encodeURIComponent(opts.cookie.name) + '=' + opts.cookie.value,
        '; max-age=' + opts.cookie.maxAge,
        '; path=/',
        '; domain=' + location.hostname,
      ].join('');
    }
  }
  const href = '//' + location.host + '/' + url.replace(/^\//, '');
  redirectInProgress = href;
  location.href = href;
};

export const unload = {
  expected: false,
};

export const reload = (err?: any) => {
  if (err) console.warn(err);
  if (redirectInProgress) return;
  unload.expected = true;
  wsDestroy();
  if (location.hash) location.reload();
  else location.assign(location.href);
};
